import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { DialogComponent } from '@theme/dialog';
import { morph } from '@theme/morph';

class PickupAvailability extends DialogComponent {
  requiredRefs = [];

  /** @type {ResizeObserver | null} */
  #resizeObserver = null;
  /** @type {Element | null} - Cached section/dialog the variant listener is attached to. */
  #variantUpdateTarget = null;

  connectedCallback() {
    super.connectedCallback();
    this.#variantUpdateTarget = this.closest('.shopify-section, dialog');
    this.#variantUpdateTarget?.addEventListener(ThemeEvents.variantUpdate, this.updatePickupAvailability);

    this.initHeightObserver();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#variantUpdateTarget?.removeEventListener(ThemeEvents.variantUpdate, this.updatePickupAvailability);
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
    if (this.handleBlockSelect) {
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  /**
   * Thêm `pickup-availability__location-info--multi-line` khi khối `.pickup-availability__location-info` cao hơn ~2 dòng.
   */
  initHeightObserver() {
    this.#resizeObserver?.disconnect();

    const update = () => {
      const el = this.querySelector('.pickup-availability__location-info');
      if (!(el instanceof HTMLElement)) return;
      const s = getComputedStyle(el);
      const lineHeight = parseFloat(s.lineHeight) || parseFloat(s.fontSize) * 1.6;
      const multi = el.scrollHeight > lineHeight * 2;
      el.classList.toggle('has-multi-line', multi);
    };

    this.#resizeObserver = new ResizeObserver(update);
    this.#resizeObserver.observe(this);
    update();
  }

  handleDesignMode() {
    this.handleBlockSelect = (event) => {
      if(this.classList.contains('dialog-component--skip-select')) return;
      if (this.contains(event.target)) {
       return;
      }
    };
    this.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePickupAvailability = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const blockId = this.dataset.blockId;
    const newPickupAvailability = blockId
      ? event.detail.data.html.querySelector(`pickup-availability[data-block-id="${blockId}"]`)
      : null;

    if (!newPickupAvailability) {
      return;
    }

    if(newPickupAvailability.classList.contains('hidden')) {
      this.classList.add('hidden');
    } else {
      this.classList.remove('hidden');
    }

    morph(this, newPickupAvailability);
    this.initHeightObserver();
  };
}

if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', PickupAvailability);
}
